import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'
import cx from 'classnames'
import { Link } from 'react-router'

import './RecurrenceCard.scss'
import ServiceItem from './components/ServiceItem'
import TableHeader from './components/TableHeader'
import { formatDate } from 'utils/dates'
import { buildAddressString } from 'utils/addresses'
import { TIMEZONE, recurrencePeriodicity } from '@src/globals'
import * as paths from 'utils/paths'

class RecurrenceCard extends Component {
  constructor (props) {
    super(props)

    this.recurrenceMoment = null
    if (props.recurrence) {
      this.recurrenceMoment = moment.tz(Date.now(0), TIMEZONE).day(props.recurrence.weekday).hour(props.recurrence.hour).minute(0)
    }

    this.cardTitle = this.cardTitle.bind(this)
    this.humanizedPeriodicity = this.humanizedPeriodicity.bind(this)
  }

  cardTitle () {
    const {
      recurrence,
      services
    } = this.props

    if (recurrence) {
      const recurrenceDayOfWeek = formatDate('dddd', this.recurrenceMoment)
      const recurrenceTime = formatDate('h:mm A', this.recurrenceMoment)

      return `Servicio de los ${recurrenceDayOfWeek} a las ${recurrenceTime}`
    } else {
      const serviceTime = formatDate('D [de] MMMM [a las] h:mm A', services[0].datetime)

      return `Servicio del ${serviceTime}`
    }
  }

  humanizedPeriodicity () {
    const { recurrence } = this.props
    const periodicity = recurrence ? recurrence.periodicity : 0
    return recurrencePeriodicity[periodicity].name
  }

  render () {
    const {
      recurrence,
      services,
      userId
    } = this.props

    const componentClassName = cx(
      'RecurrenceCard',
      {
        'RecurrenceCard--recurrence': recurrence,
        'RecurrenceCard--oneTime': !recurrence
      }
    )

    const address = recurrence ? recurrence.address : services[0].address

    return (
      <div className={componentClassName}>
        <div className='RecurrenceCard-header'>
          <h4>{this.cardTitle()}</h4>
          <div className='RecurrenceCard-headerInfo'>
            <div className='RecurrenceCard-periodicity'>{this.humanizedPeriodicity()}</div>
            {
              recurrence &&
              (
                <div className='RecurrenceCard-modifyRecurrence'>
                  <Link
                    className='btn btn-primary'
                    to={paths.userModifyRecurrence(userId, recurrence.id)}
                    >
                    Modificar todo
                  </Link>
                  <Link
                    className='btn btn-primary'
                    to={paths.userCancelRecurrence(userId, recurrence.id)}
                    >
                    Cancelar todo
                  </Link>
                </div>
              )
            }
          </div>
        </div>
        <div className='RecurrenceCard-address'>
          {buildAddressString(address)}
        </div>
        <TableHeader />
        <div className='RecurrenceCard-services'>
          {
            services.map((service, index) => {
              let modified = false
              const serviceMoment = moment(service.datetime)
              if (
                recurrence &&
                (
                  serviceMoment.day() !== this.recurrenceMoment.day() ||
                  serviceMoment.hour() !== this.recurrenceMoment.hour()
                )
              ) {
                modified = true
              }
              return <ServiceItem key={index} service={service} userId={userId} modified={modified} />
            })
          }
        </div>
      </div>
    )
  }
}

RecurrenceCard.displayName = 'RecurrenceCard'
RecurrenceCard.propTypes = {
  recurrence: PropTypes.shape({
    id: PropTypes.number.isRequired,
    weekday: PropTypes.string.isRequired,
    periodicity: PropTypes.number.isRequired,
    hour: PropTypes.number.isRequired
  }),
  services: PropTypes.array.isRequired,
  userId: PropTypes.string.isRequired
}
RecurrenceCard.defaultProps = {
  recurrence: null
}

export default RecurrenceCard



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices/components/RecurrenceCard/RecurrenceCard.js